import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";
import { RequestModel } from "model";
import { RequestType } from "pages/RequestIndex/RequestIndex";

import RequestItemView from "~components/RequestItem/RequestItemView";

import styles from "./RequestIndexView.module.css";

type RequestIndexViewProps = {
  requests: Array<RequestModel>;
  requestType: RequestType;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  isFetchingNextPage?: boolean;
};

export function RequestIndexView(props: RequestIndexViewProps) {
  const { requests, requestType, hasNextPage, fetchNextPage } = props;

  const handleInfiniteScroll = async (event: CustomEvent) => {
    if (fetchNextPage && hasNextPage) {
      await fetchNextPage();
    }
    (event.target as HTMLIonInfiniteScrollElement).complete();
  };

  return (
    <>
      <div className={styles.requestIndexViewContainer}>
        {requests.map((item: RequestModel, idx: number) => (
          <RequestItemView request={item} key={`${item.id}-${idx}`} requestType={requestType} />
        ))}
      </div>
      {hasNextPage && (
        <IonInfiniteScroll onIonInfinite={handleInfiniteScroll} threshold="100px">
          <IonInfiniteScrollContent loadingText="Loading more requests..." />
        </IonInfiniteScroll>
      )}
    </>
  );
}
